// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Header_nav__T0AXG {
  background-color: var(--color-white);
  display: flex;
  padding: 3rem 10rem;
  justify-content: space-between;
  align-items: center;
}
@media only screen and (max-width: 37.5em) {
  .Header_nav__T0AXG {
    padding: 3rem 5rem;
  }
}
.Header_nav__T0AXG img {
  width: 10rem;
}
.Header_nav__ul__qaWBf {
  display: flex;
  align-items: center;
  list-style: none;
  gap: 2.5rem;
}
@media only screen and (max-width: 62.5em) {
  .Header_nav__ul__qaWBf {
    display: none;
  }
}
.Header_nav__ul__qaWBf li {
  color: var(--color-dark);
  cursor: pointer;
}
.Header_nav__ul__qaWBf li:hover {
  font-weight: 700;
  color: var(--color-fash-primary-2);
}
.Header_nav__btns__farTh {
  display: flex;
  gap: 2.5rem;
}
@media only screen and (max-width: 62.5em) {
  .Header_nav__btns__farTh {
    display: none;
  }
}
.Header_nav__open__mwlOS {
  display: none;
  cursor: pointer;
  font-size: 5rem;
}
.Header_nav__open__mwlOS:hover {
  color: var(--color-fash-primary-2);
}
@media only screen and (max-width: 62.5em) {
  .Header_nav__open__mwlOS {
    display: block;
  }
}
.Header_nav__mobile__LOXF6 {
  width: 100vw;
  height: 100vh;
  background-color: var(--color-white);
  position: fixed;
  padding: 5rem 10rem;
  z-index: 100;
  overflow-y: scroll;
}
@media only screen and (max-width: 37.5em) {
  .Header_nav__mobile__LOXF6 {
    padding: 5rem;
  }
}
.Header_nav__mobile__LOXF6 img {
  width: 10rem;
}
.Header_nav__mobile__top__4w9YQ {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
}
.Header_nav__mobile__ul__wcGLt {
  min-height: 50vh;
  display: flex;
  flex-direction: column;
  font-size: var(--default-font-subtitle);
  text-align: center;
  justify-content: space-evenly;
  margin-bottom: 2rem;
  list-style: none;
}
.Header_nav__mobile__btns__Hvmka {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.Header_nav__close__fme5P {
  cursor: pointer;
  font-size: 5rem;
}
.Header_nav__close__fme5P:hover {
  color: var(--color-fash-primary-2);
}

.Header_line__kgJ5N {
  content: "";
  width: 100%;
  border-bottom: 1rem solid var(--color-fash-primary);
}

.Header_hero__1zTiT {
  width: 100%;
  height: 80vh;
  background-image: linear-gradient(97deg, rgb(12, 9, 13) 35%, rgba(12, 9, 13, 0) 100%), url(https://res.cloudinary.com/mima-business/image/upload/v1712942258/fash%20creatives%20web/stylish-african-american-woman-by-cafe_gmwpfc.jpg);
  color: var(--color-white);
  background-size: auto, 120%;
  background-repeat: repeat, no-repeat;
  background-position: 0 0, 40% 5%;
  padding: 5rem 10rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 2rem;
  position: relative;
  box-sizing: border-box;
}
@media only screen and (max-width: 62.5em) {
  .Header_hero__1zTiT {
    background-size: auto, 170%;
    background-position: 0 0, 40% 50%;
  }
}
@media only screen and (max-width: 43.75em) {
  .Header_hero__1zTiT {
    background-size: auto, 190%;
  }
}
@media only screen and (max-width: 37.5em) {
  .Header_hero__1zTiT {
    padding: 5rem;
    background-size: auto, 260%;
    background-position: 0 0, 50% 50%;
    min-height: 70vh;
  }
}
.Header_hero__1zTiT h1 {
  font-family: var(--secondary-font);
  font-size: 10rem;
  font-weight: 700;
  width: 60%;
  line-height: 9rem;
}
@media only screen and (max-width: 62.5em) {
  .Header_hero__1zTiT h1 {
    font-size: 7rem;
    width: 80%;
  }
}
@media only screen and (max-width: 37.5em) {
  .Header_hero__1zTiT h1 {
    width: 100%;
  }
}
.Header_hero__1zTiT p {
  font-size: 2.4rem;
  width: 60%;
}
@media only screen and (max-width: 62.5em) {
  .Header_hero__1zTiT p {
    width: 80%;
  }
}
@media only screen and (max-width: 43.75em) {
  .Header_hero__1zTiT p {
    width: 100%;
  }
}
.Header_hero__shape__h\\+x5m {
  position: absolute;
  bottom: -2px;
  right: 0;
  z-index: 12;
  width: 50%;
}

.Header_dl__kJ9sq {
  margin: 5rem 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 5rem;
  gap: 2rem;
  box-sizing: border-box;
}
@media only screen and (max-width: 37.5em) {
  .Header_dl__kJ9sq {
    flex-direction: column;
  }
}

.Header_header__\\+KzXD {
  padding: 5rem 9.5rem;
  box-sizing: border-box;
}
@media only screen and (max-width: 62.5em) {
  .Header_header__\\+KzXD {
    padding: 5rem 5rem;
  }
}
.Header_header__nav__SGdc3 {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}
@media only screen and (max-width: 62.5em) {
  .Header_header__nav__SGdc3 {
    justify-content: space-between;
  }
}
.Header_header__nav__btn__YIhaR {
  display: flex;
  gap: 2.3rem;
}
@media only screen and (max-width: 62.5em) {
  .Header_header__nav__btn__YIhaR {
    display: none;
  }
}
.Header_header__nav_icon__EyHJS {
  display: none;
  cursor: pointer;
}
@media only screen and (max-width: 62.5em) {
  .Header_header__nav_icon__EyHJS {
    display: block;
    font-size: 5rem;
  }
  .Header_header__nav_icon__EyHJS:hover {
    color: var(--color-primary);
  }
}

.Header_logo__exjkz {
  width: 18rem;
  height: 100%;
}

.Header_btn__icon__DTU\\+U {
  height: 2.2rem;
  margin-right: 1rem;
}

.Header_slide__uNopk {
  margin-top: 10rem;
  display: grid;
  grid-template-columns: repeat(2, max-content);
  justify-content: center;
  box-sizing: border-box;
}
@media only screen and (max-width: 62.5em) {
  .Header_slide__uNopk {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 3rem;
    margin-top: 4rem;
  }
}
.Header_slide__text__W0eyd {
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: 65rem;
  padding-right: 2rem;
}
@media only screen and (max-width: 62.5em) {
  .Header_slide__text__W0eyd {
    text-align: center;
  }
}
.Header_slide__text_btn__VKJ0U {
  display: flex;
  gap: 2rem;
}
@media only screen and (max-width: 62.5em) {
  .Header_slide__text_btn__VKJ0U {
    justify-content: center;
  }
}
@media only screen and (max-width: 37.5em) {
  .Header_slide__text_btn__VKJ0U {
    flex-direction: column;
    align-items: center;
  }
}
.Header_slide__img__RVwmC {
  width: 58rem;
}
@media only screen and (max-width: 62.5em) {
  .Header_slide__img__RVwmC {
    width: 40rem;
  }
}

.Header_menu__5ACxl {
  width: 100vw;
  height: 100vh;
  background-color: var(--color-light);
  position: fixed;
  padding: 5rem 10rem;
  overflow-y: scroll;
  z-index: 100;
}
@media only screen and (max-width: 37.5em) {
  .Header_menu__5ACxl {
    padding: 5rem 5rem;
  }
}
.Header_menu__logo__zeBtA {
  width: 18rem;
}
.Header_menu__top__wQs-k {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
}
.Header_menu__icon__EVWCp {
  font-size: 5rem;
  color: var(--color-primary);
  cursor: pointer;
}
.Header_menu__nav__gLaK\\+ {
  height: 50vh;
  display: flex;
  flex-direction: column;
  font-size: var(--default-font-subtitle);
  text-align: center;
  justify-content: space-evenly;
  margin-bottom: 2rem;
}
.Header_menu__nav__item__BtO8M {
  list-style: none;
}
.Header_menu__nav__link__y\\+JQf {
  cursor: pointer;
  text-decoration: none;
  color: var(--color-dark);
}
.Header_menu__nav__link__y\\+JQf:hover, .Header_menu__nav__link__y\\+JQf:focus {
  font-weight: 700;
  color: var(--color-primary);
}
.Header_menu__nav__btn__w3G6K {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.Header_main__4dfNU {
  position: relative;
}

.Header_modal__4KfLZ {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
}
.Header_modal__4KfLZ img {
  height: 27rem;
  border-radius: 3rem;
  margin: 2rem 0;
}

.Header_businesses__SPQKe {
  margin-top: 4rem;
  text-align: center;
}
@media only screen and (max-width: 62.5em) {
  .Header_businesses__title__lLmVq {
    font-size: var(--default-font-h3);
  }
}
.Header_businesses__list__rADG2 {
  display: flex;
  justify-content: space-between;
  margin-right: 2rem;
  color: var(--color-grey);
}
.Header_businesses__img__3VM7r {
  height: 5rem;
  width: 10rem;
  object-fit: cover;
  border-radius: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/LandingPage/Header.module.scss"],"names":[],"mappings":"AAEA;EACC,oCAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AADD;AAGC;EAPD;IAQE,kBAAA;EAAA;AACF;AAEC;EACC,YAAA;AAAF;AAGC;EACC,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;AADF;AAGE;EAND;IAOE,aAAA;EAAD;AACF;AAEE;EACC,wBAAA;EACA,eAAA;AAAH;AAEG;EACC,gBAAA;EACA,kCAAA;AAAJ;AAKC;EACC,aAAA;EACA,WAAA;AAHF;AAKE;EAJD;IAKE,aAAA;EAFD;AACF;AAKC;EACC,aAAA;EACA,eAAA;EACA,eAAA;AAHF;AAKE;EACC,kCAAA;AAHH;AAME;EATD;IAUE,cAAA;EAHD;AACF;AAMC;EACC,YAAA;EACA,aAAA;EACA,oCAAA;EACA,eAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;AAJF;AAME;EATD;IAUE,aAAA;EAHD;AACF;AAME;EACC,YAAA;AAJH;AAOE;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AALH;AAQE;EACC,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,uCAAA;EACA,kBAAA;EACA,6BAAA;EACA,mBAAA;EACA,gBAAA;AANH;AAUE;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;AARH;AAYC;EACC,eAAA;EACA,eAAA;AAVF;AAYE;EACC,kCAAA;AAVH;;AAgBA;EACC,WAAA;EACA,WAAA;EACA,mDAAA;AAbD;;AAgBA;EACC,WAAA;EACA,YAAA;EACA,sOAAA;EACA,yBAAA;EACA,2BAAA;EACA,oCAAA;EACA,gCAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;EACA,kBAAA;EACA,sBAAA;AAbD;AAeC;EAhBD;IAiBE,2BAAA;IACA,iCAAA;EAZA;AACF;AAcC;EArBD;IAsBE,2BAAA;EAXA;AACF;AAaC;EAzBD;IA0BE,aAAA;IACA,2BAAA;IACA,iCAAA;IACA,gBAAA;EAVA;AACF;AAcC;EACC,kCAAA;EACA,gBAAA;EACA,gBAAA;EACA,UAAA;EACA,iBAAA;AAZF;AAcE;EAPD;IAQE,eAAA;IACA,UAAA;EAXD;AACF;AAaE;EAZD;IAaE,WAAA;EAVD;AACF;AAaC;EACC,iBAAA;EACA,UAAA;AAXF;AAaE;EAJD;IAKE,UAAA;EAVD;AACF;AAYE;EARD;IASE,WAAA;EATD;AACF;AAYC;EACC,kBAAA;EACA,YAAA;EACA,QAAA;EACA,WAAA;EACA,UAAA;AAVF;;AAcA;EACC,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,SAAA;EACA,sBAAA;AAXD;AAaC;EATD;IAUE,sBAAA;EAVA;AACF;;AAeA;EACC,oBAAA;EACA,sBAAA;AAZD;AAcC;EAJD;IAKE,kBAAA;EAXA;AACF;AAaC;EACC,aAAA;EACA,6BAAA;EACA,mBAAA;AAXF;AAaE;EALD;IAME,8BAAA;EAVD;AACF;AAYE;EACC,aAAA;EACA,WAAA;AAVH;AAYG;EAJD;IAKE,aAAA;EATF;AACF;AAYE;EACC,aAAA;EACA,eAAA;AAVH;AAYG;EAJD;IAKE,cAAA;IACA,eAAA;EATF;EAWE;IACC,2BAAA;EATH;AACF;;AAeA;EACC,YAAA;EACA,YAAA;AAZD;;AA0DC;EACC,cAAA;EACA,kBAAA;AAvDF;;AA4DA;EACC,iBAAA;EACA,aAAA;EACA,6CAAA;EACA,uBAAA;EACA,sBAAA;AAzDD;AA2DC;EAPD;IAQE,aAAA;IACA,sBAAA;IACA,mBAAA;IACA,SAAA;IACA,gBAAA;EAxDA;AACF;AA0DC;EACC,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;AAxDF;AA0DE;EAPD;IAQE,kBAAA;EAvDD;AACF;AAyDE;EACC,aAAA;EACA,SAAA;AAvDH;AAyDG;EAJD;IAKE,uBAAA;EAtDF;AACF;AAwDG;EARD;IASE,sBAAA;IACA,mBAAA;EArDF;AACF;AAyDC;EACC,YAAA;AAvDF;AAyDE;EAHD;IAIE,YAAA;EAtDD;AACF;;AA0DA;EACC,YAAA;EACA,aAAA;EACA,oCAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;AAvDD;AAyDC;EATD;IAUE,kBAAA;EAtDA;AACF;AAwDC;EACC,YAAA;AAtDF;AAyDC;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AAvDF;AA0DC;EACC,eAAA;EACA,2BAAA;EACA,eAAA;AAxDF;AA2DC;EACC,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uCAAA;EACA,kBAAA;EACA,6BAAA;EACA,mBAAA;AAzDF;AA2DE;EACC,gBAAA;AAzDH;AA4DE;EACC,eAAA;EACA,qBAAA;EACA,wBAAA;AA1DH;AA4DG;EAEC,gBAAA;EACA,2BAAA;AA3DJ;AA+DE;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;AA7DH;;AAkEA;EACC,kBAAA;AA/DD;;AAkEA;EACC,kBAAA;EACA,OAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;AA/DD;AAiEC;EACC,aAAA;EACA,mBAAA;EACA,cAAA;AA/DF;;AAmEA;EACC,gBAAA;EACA,kBAAA;AAhED;AAoEE;EAFD;IAGE,iCAAA;EAjED;AACF;AAoEC;EACC,aAAA;EACA,8BAAA;EACA,kBAAA;EACA,wBAAA;AAlEF;AAqEC;EACC,YAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;AAnEF","sourcesContent":["@import '../variables/breakpoints';\n\n.nav {\n\tbackground-color: var(--color-white);\n\tdisplay: flex;\n\tpadding: 3rem 10rem;\n\tjustify-content: space-between;\n\talign-items: center;\n\n\t@media only screen and (max-width: $bp-600) {\n\t\tpadding: 3rem 5rem;\n\t}\n\n\timg {\n\t\twidth: 10rem\n\t}\n\n\t&__ul {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tlist-style: none;\n\t\tgap: 2.5rem;\n\n\t\t@media only screen and (max-width: $bp-1000) {\n\t\t\tdisplay: none;\n\t\t}\n\n\t\tli {\n\t\t\tcolor: var(--color-dark);\n\t\t\tcursor: pointer;\n\n\t\t\t&:hover {\n\t\t\t\tfont-weight: 700;\n\t\t\t\tcolor: var(--color-fash-primary-2);\n\t\t\t}\n\t\t}\n\t}\n\n\t&__btns {\n\t\tdisplay: flex;\n\t\tgap: 2.5rem;\n\n\t\t@media only screen and (max-width: $bp-1000) {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n\n\t&__open {\n\t\tdisplay: none;\n\t\tcursor: pointer;\n\t\tfont-size: 5rem;\n\n\t\t&:hover {\n\t\t\tcolor: var(--color-fash-primary-2);\n\t\t}\n\n\t\t@media only screen and (max-width: $bp-1000) {\n\t\t\tdisplay: block;\n\t\t}\n\t}\n\n\t&__mobile {\n\t\twidth: 100vw;\n\t\theight: 100vh;\n\t\tbackground-color: var(--color-white);\n\t\tposition: fixed;\n\t\tpadding: 5rem 10rem;\n\t\tz-index: 100;\n\t\toverflow-y: scroll;\n\n\t\t@media only screen and (max-width: $bp-600) {\n\t\t\tpadding: 5rem;\n\n\t\t}\n\n\t\timg {\n\t\t\twidth: 10rem\n\t\t}\n\n\t\t&__top {\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: space-between;\n\t\t\talign-items: center;\n\t\t\tmargin-bottom: 2rem;\n\t\t}\n\n\t\t&__ul {\n\t\t\tmin-height: 50vh;\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t\tfont-size: var(--default-font-subtitle);\n\t\t\ttext-align: center;\n\t\t\tjustify-content: space-evenly;\n\t\t\tmargin-bottom: 2rem;\n\t\t\tlist-style: none;\n\t\t}\n\n\n\t\t&__btns {\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t\talign-items: center;\n\t\t}\n\t}\n\n\t&__close {\n\t\tcursor: pointer;\n\t\tfont-size: 5rem;\n\n\t\t&:hover {\n\t\t\tcolor: var(--color-fash-primary-2);\n\t\t}\n\n\t}\n}\n\n.line {\n\tcontent: \"\";\n\twidth: 100%;\n\tborder-bottom: 1rem solid var(--color-fash-primary);\n}\n\n.hero {\n\twidth: 100%;\n\theight: 80vh;\n\tbackground-image: linear-gradient(97deg, rgba(12, 9, 13, 1) 35%, rgba(12, 9, 13, 0) 100%), url(https://res.cloudinary.com/mima-business/image/upload/v1712942258/fash%20creatives%20web/stylish-african-american-woman-by-cafe_gmwpfc.jpg);\n\tcolor: var(--color-white);\n\tbackground-size: auto, 120%;\n\tbackground-repeat: repeat, no-repeat;\n\tbackground-position: 0 0, 40% 5%;\n\tpadding: 5rem 10rem;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\tgap: 2rem;\n\tposition: relative;\n\tbox-sizing: border-box;\n\n\t@media only screen and (max-width: $bp-1000) {\n\t\tbackground-size: auto, 170%;\n\t\tbackground-position: 0 0, 40% 50%;\n\t}\n\n\t@media only screen and (max-width: $bp-700) {\n\t\tbackground-size: auto, 190%;\n\t}\n\n\t@media only screen and (max-width: $bp-600) {\n\t\tpadding: 5rem;\n\t\tbackground-size: auto, 260%;\n\t\tbackground-position: 0 0, 50% 50%;\n\t\tmin-height: 70vh;\n\n\t}\n\n\n\th1 {\n\t\tfont-family: var(--secondary-font);\n\t\tfont-size: 10rem;\n\t\tfont-weight: 700;\n\t\twidth: 60%;\n\t\tline-height: 9rem;\n\n\t\t@media only screen and (max-width: $bp-1000) {\n\t\t\tfont-size: 7rem;\n\t\t\twidth: 80%;\n\t\t}\n\n\t\t@media only screen and (max-width: $bp-600) {\n\t\t\twidth: 100%;\n\t\t}\n\t}\n\n\tp {\n\t\tfont-size: 2.4rem;\n\t\twidth: 60%;\n\n\t\t@media only screen and (max-width: $bp-1000) {\n\t\t\twidth: 80%;\n\t\t}\n\n\t\t@media only screen and (max-width: $bp-700) {\n\t\t\twidth: 100%;\n\t\t}\n\t}\n\n\t&__shape {\n\t\tposition: absolute;\n\t\tbottom: -2px;\n\t\tright: 0;\n\t\tz-index: 12;\n\t\twidth: 50%;\n\t}\n}\n\n.dl {\n\tmargin: 5rem 0;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tpadding: 0 5rem;\n\tgap: 2rem;\n\tbox-sizing: border-box;\n\n\t@media only screen and (max-width: $bp-600) {\n\t\tflex-direction: column;\n\t}\n}\n\n\n\n.header {\n\tpadding: 5rem 9.5rem;\n\tbox-sizing: border-box;\n\n\t@media only screen and (max-width: $bp-large) {\n\t\tpadding: 5rem 5rem;\n\t}\n\n\t&__nav {\n\t\tdisplay: flex;\n\t\tjustify-content: space-evenly;\n\t\talign-items: center;\n\n\t\t@media only screen and (max-width: $bp-large) {\n\t\t\tjustify-content: space-between;\n\t\t}\n\n\t\t&__btn {\n\t\t\tdisplay: flex;\n\t\t\tgap: 2.3rem;\n\n\t\t\t@media only screen and (max-width: $bp-large) {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t}\n\n\t\t&_icon {\n\t\t\tdisplay: none;\n\t\t\tcursor: pointer;\n\n\t\t\t@media only screen and (max-width: $bp-large) {\n\t\t\t\tdisplay: block;\n\t\t\t\tfont-size: 5rem;\n\n\t\t\t\t&:hover {\n\t\t\t\t\tcolor: var(--color-primary);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n.logo {\n\twidth: 18rem;\n\theight: 100%;\n}\n\n// .nav {\n// \t&__item {\n// \t\tdisplay: flex;\n// \t\tlist-style: none;\n\n// \t\t&__list {\n// \t\t\ttext-decoration: none;\n// \t\t\tcolor: var(--color-dark);\n// \t\t\tcursor: pointer;\n\n// \t\t\t&:hover,\n// \t\t\t&:active {\n// \t\t\t\tfont-weight: 700;\n// \t\t\t\tcolor: var(--color-primary);\n// \t\t\t}\n\n// \t\t\t&:not(:last-child) {\n// \t\t\t\tmargin-right: 2.5rem;\n// \t\t\t}\n// \t\t}\n\n// \t\t&__link:link,\n// \t\t&__link:visited {\n// \t\t\ttext-decoration: none;\n// \t\t\tcolor: var(--color-dark);\n// \t\t\tcursor: pointer;\n\n// \t\t\t&:hover,\n// \t\t\t&:active {\n// \t\t\t\tfont-weight: 700;\n// \t\t\t\tcolor: var(--color-primary);\n// \t\t\t}\n// \t\t}\n\n// \t\t@media only screen and (max-width: $bp-large) {\n// \t\t\tdisplay: none;\n// \t\t}\n// \t}\n// }\n\n// button style\n\n.btn {\n\t&__icon {\n\t\theight: 2.2rem;\n\t\tmargin-right: 1rem;\n\t}\n}\n\n//Slide section\n.slide {\n\tmargin-top: 10rem;\n\tdisplay: grid;\n\tgrid-template-columns: repeat(2, max-content);\n\tjustify-content: center;\n\tbox-sizing: border-box;\n\n\t@media only screen and (max-width: $bp-large) {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t\tgap: 3rem;\n\t\tmargin-top: 4rem;\n\t}\n\n\t&__text {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tjustify-content: center;\n\t\tmax-width: 65rem;\n\t\tpadding-right: 2rem;\n\n\t\t@media only screen and (max-width: $bp-large) {\n\t\t\ttext-align: center;\n\t\t}\n\n\t\t&_btn {\n\t\t\tdisplay: flex;\n\t\t\tgap: 2rem;\n\n\t\t\t@media only screen and (max-width: $bp-large) {\n\t\t\t\tjustify-content: center;\n\t\t\t}\n\n\t\t\t@media only screen and (max-width: $bp-small) {\n\t\t\t\tflex-direction: column;\n\t\t\t\talign-items: center;\n\t\t\t}\n\t\t}\n\t}\n\n\t&__img {\n\t\twidth: 58rem;\n\n\t\t@media only screen and (max-width: $bp-large) {\n\t\t\twidth: 40rem;\n\t\t}\n\t}\n}\n\n.menu {\n\twidth: 100vw;\n\theight: 100vh;\n\tbackground-color: var(--color-light);\n\tposition: fixed;\n\tpadding: 5rem 10rem;\n\toverflow-y: scroll;\n\tz-index: 100;\n\n\t@media only screen and (max-width: $bp-small) {\n\t\tpadding: 5rem 5rem;\n\t}\n\n\t&__logo {\n\t\twidth: 18rem;\n\t}\n\n\t&__top {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\t\tmargin-bottom: 2rem;\n\t}\n\n\t&__icon {\n\t\tfont-size: 5rem;\n\t\tcolor: var(--color-primary);\n\t\tcursor: pointer;\n\t}\n\n\t&__nav {\n\t\theight: 50vh;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tfont-size: var(--default-font-subtitle);\n\t\ttext-align: center;\n\t\tjustify-content: space-evenly;\n\t\tmargin-bottom: 2rem;\n\n\t\t&__item {\n\t\t\tlist-style: none;\n\t\t}\n\n\t\t&__link {\n\t\t\tcursor: pointer;\n\t\t\ttext-decoration: none;\n\t\t\tcolor: var(--color-dark);\n\n\t\t\t&:hover,\n\t\t\t&:focus {\n\t\t\t\tfont-weight: 700;\n\t\t\t\tcolor: var(--color-primary);\n\t\t\t}\n\t\t}\n\n\t\t&__btn {\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t\talign-items: center;\n\t\t}\n\t}\n}\n\n.main {\n\tposition: relative;\n}\n\n.modal {\n\tposition: absolute;\n\tleft: 0;\n\ttop: 0;\n\tright: 0;\n\tbottom: 0;\n\n\timg {\n\t\theight: 27rem;\n\t\tborder-radius: 3rem;\n\t\tmargin: 2rem 0;\n\t}\n}\n\n.businesses {\n\tmargin-top: 4rem;\n\ttext-align: center;\n\n\t&__title {\n\n\t\t@media only screen and (max-width: $bp-large) {\n\t\t\tfont-size: var(--default-font-h3);\n\t\t}\n\t}\n\n\t&__list {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\tmargin-right: 2rem;\n\t\tcolor: var(--color-grey);\n\t}\n\n\t&__img {\n\t\theight: 5rem;\n\t\twidth: 10rem;\n\t\tobject-fit: cover;\n\t\tborder-radius: 1rem;\n\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"nav": `Header_nav__T0AXG`,
	"nav__ul": `Header_nav__ul__qaWBf`,
	"nav__btns": `Header_nav__btns__farTh`,
	"nav__open": `Header_nav__open__mwlOS`,
	"nav__mobile": `Header_nav__mobile__LOXF6`,
	"nav__mobile__top": `Header_nav__mobile__top__4w9YQ`,
	"nav__mobile__ul": `Header_nav__mobile__ul__wcGLt`,
	"nav__mobile__btns": `Header_nav__mobile__btns__Hvmka`,
	"nav__close": `Header_nav__close__fme5P`,
	"line": `Header_line__kgJ5N`,
	"hero": `Header_hero__1zTiT`,
	"hero__shape": `Header_hero__shape__h+x5m`,
	"dl": `Header_dl__kJ9sq`,
	"header": `Header_header__+KzXD`,
	"header__nav": `Header_header__nav__SGdc3`,
	"header__nav__btn": `Header_header__nav__btn__YIhaR`,
	"header__nav_icon": `Header_header__nav_icon__EyHJS`,
	"logo": `Header_logo__exjkz`,
	"btn__icon": `Header_btn__icon__DTU+U`,
	"slide": `Header_slide__uNopk`,
	"slide__text": `Header_slide__text__W0eyd`,
	"slide__text_btn": `Header_slide__text_btn__VKJ0U`,
	"slide__img": `Header_slide__img__RVwmC`,
	"menu": `Header_menu__5ACxl`,
	"menu__logo": `Header_menu__logo__zeBtA`,
	"menu__top": `Header_menu__top__wQs-k`,
	"menu__icon": `Header_menu__icon__EVWCp`,
	"menu__nav": `Header_menu__nav__gLaK+`,
	"menu__nav__item": `Header_menu__nav__item__BtO8M`,
	"menu__nav__link": `Header_menu__nav__link__y+JQf`,
	"menu__nav__btn": `Header_menu__nav__btn__w3G6K`,
	"main": `Header_main__4dfNU`,
	"modal": `Header_modal__4KfLZ`,
	"businesses": `Header_businesses__SPQKe`,
	"businesses__title": `Header_businesses__title__lLmVq`,
	"businesses__list": `Header_businesses__list__rADG2`,
	"businesses__img": `Header_businesses__img__3VM7r`
};
export default ___CSS_LOADER_EXPORT___;
